var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 5.83325C11.0661 5.83325 5.83325 11.0661 5.83325 17.4999C5.83325 23.9337 11.0661 29.1666 17.4999 29.1666C23.9337 29.1666 29.1666 23.9337 29.1666 17.4999C29.1666 11.0661 23.9337 5.83325 17.4999 5.83325ZM25.1533 12.1737L24.643 14.5257L21.003 16.075L20.5177 16.1933L18.0848 14.4261V10.0768L20.1693 8.55859C22.2101 9.16836 23.9586 10.4626 25.1533 12.1737ZM14.8306 8.55859L16.915 10.0768V14.4261L14.7497 16.0004L10.363 14.5755L9.84658 12.1737C11.0413 10.4626 12.7897 9.17459 14.8306 8.55859ZM8.16659 17.4999C8.16659 17.1701 8.18525 16.8466 8.21636 16.5293L9.78436 15.6208L13.9657 16.9773L15.0173 20.219L14.7373 20.6484L13.3933 23.1061L13.2564 23.3737L10.2697 23.3924C8.95681 21.7808 8.16659 19.7337 8.16659 17.4999ZM14.9426 26.4661L14.171 24.1453L14.4261 23.6475L15.739 21.2457L15.9506 20.9221H18.9248L20.499 23.7035L20.7479 24.0581L19.9328 26.5035C19.155 26.715 18.3399 26.8395 17.4999 26.8395C16.6101 26.8333 15.7577 26.7026 14.9426 26.4661ZM24.7301 23.3924L21.6875 23.3737L21.4821 23.0813L19.9328 20.3435L20.9284 17.2884L21.3701 17.1826L25.147 15.5773L26.7835 16.5293C26.8146 16.8466 26.8333 17.1764 26.8333 17.4999C26.8333 19.7337 26.043 21.7808 24.7301 23.3924Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.d2c0d1e9c19e453ad54e3034c6af117f.svg";
export { ForwardRef as ReactComponent };